import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { GALLERY } from "@/lib/data";
import { Reveal, Label } from "@/components/Reveal";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery" className="relative py-24 md:py-32 bg-[#0A0E14]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <Label>05 — Portfolio</Label>
              <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5">
                Esempi di stampa 3D.
              </h2>
            </div>
            <p className="text-slate-400 max-w-sm leading-relaxed">
              Ogni pezzo nasce da un file e da un&apos;esigenza reale: prototipi, plastici, oggetti
              su misura.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className={`group relative overflow-hidden bg-[#111827] border border-white/10 ${
                i === 0 ? "md:col-span-7 md:row-span-2" : "md:col-span-5"
              }`}
            >
              <div className={`overflow-hidden ${i === 0 ? "aspect-[4/3] md:aspect-auto md:h-full" : "aspect-[16/10]"}`}>
                <img
                  src={g.url}
                  alt={g.t}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E14] via-transparent to-transparent opacity-80" />
              <div className="absolute inset-0 bg-[#00C8D7]/0 group-hover:bg-[#00C8D7]/10 transition-colors" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between">
                <div>
                  <span className="font-mono-tech text-xs uppercase tracking-[0.2em] text-[#00C8D7]">
                    {g.tag}
                  </span>
                  <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight mt-1">
                    {g.t}
                  </h3>
                </div>
                <ArrowUpRight
                  size={24}
                  className="text-white/40 group-hover:text-[#00C8D7] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
                />
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
